var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.5H9.49395C8.87617 12.2478 7.20933 13.5 5.25 13.5C2.76472 13.5 0.75 11.4853 0.75 9C0.75 6.51472 2.76472 4.5 5.25 4.5C7.20933 4.5 8.87617 5.75222 9.49395 7.5H17.25V10.5H15.75V13.5H12.75V10.5ZM5.25 10.5C6.07843 10.5 6.75 9.82845 6.75 9C6.75 8.17155 6.07843 7.5 5.25 7.5C4.42157 7.5 3.75 8.17155 3.75 9C3.75 9.82845 4.42157 10.5 5.25 10.5Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/icon_password.672df3420a669dfc736c010f08c0ca18.svg";
export { ForwardRef as ReactComponent };